export default __webpack_public_path__ + "static/media/bihorelmini.0116ecbc.jpg";